module.exports = __webpack_public_path__ + "img/sv82on.e78c836e.svg";